import { Divider, Stack } from '@mui/material';
import { MapRef } from 'react-map-gl/mapbox';

import MapFullscreenControl from './MapFullscreenControl';
import MapNavigationControl from './MapNavigationControl';
import MapSearchControl from './MapSearchControl';

interface MapControlsProps {
  mapRef: MapRef | null;
  mapboxAccessToken: string;
  mapContainerId?: string;
}

const MapControls = ({
  mapboxAccessToken,
  mapContainerId,
  mapRef,
}: MapControlsProps) => {
  return (
    <Stack
      position='absolute'
      divider={<Divider flexItem sx={{ borderBottomWidth: 2 }} />}
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 0.5,
        border: 1,
        borderColor: 'divider',
        bottom: (theme) => theme.spacing(5),
        left: (theme) => theme.spacing(1.5),
      }}
      zIndex={1}
    >
      <MapSearchControl mapRef={mapRef} mapboxAccessToken={mapboxAccessToken} />
      <MapFullscreenControl mapRef={mapRef} containerId={mapContainerId} />
      <MapNavigationControl mapRef={mapRef} />
    </Stack>
  );
};

export default MapControls;
